import { render } from "./indexAllotmentComponent.vue?vue&type=template&id=f3f6edac"
import script from "./indexAllotmentComponent.vue?vue&type=script&lang=js"
export * from "./indexAllotmentComponent.vue?vue&type=script&lang=js"

import "./indexAllotmentComponent.vue?vue&type=style&index=0&id=f3f6edac&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__